import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {ResponseEvent, EventInitState, SeedEvent, FilterEvent, EventType} from '@/store/event/event.types';
import {EventEnumApi} from '@/store/event/event.enum';
import {HttpService} from '@/services/api';
import {FilesEnumApi} from '@/store/files/files.enum';

export const EventAction: ActionTree<EventInitState, RootState> = {
  async _getEventMemberForMember(req: ActionContext<EventInitState, RootState>, params: {filter?: FilterEvent, branchId?: string}): Promise<void> {
    let {commit} = req;
    try {
      // console.log(branchId)
      let events = await HttpService.post(`${EventEnumApi.event}member/${params.branchId}`, params.filter) as { data: ResponseEvent };
      if (events.data.appCode === 20000) {
        for (const row of events.data.data) {
          let tmp = await HttpService.get(`${FilesEnumApi.asset}public/primary/${row.imgRef}`, {}, process.env.VUE_APP_API_FILES);
          if (tmp.data.data[0] === null) {
            row.img = 'https://timebank-spaces.sgp1.digitaloceanspaces.com/39dc8b1e-b9c2-4195-b2f8-ea2be77a7b8c.png';
          } else {
            row.img = tmp.data.data[0].filePath
          }
        }
        commit('mutationGetEventMember', events.data.data);
      } else {
        commit('mutationGetEventMember', []);
      }
    } catch (e) {
      commit('mutationGetEventMember', []);
      console.error('DEBUG: _getEvent ', e.message);
    }
  },
  async _getEventMemberForTime(req: ActionContext<EventInitState, RootState>, params?: FilterEvent): Promise<void> {
    let {commit} = req;
    try {
      let events = await HttpService.get(`${EventEnumApi.event}member`, params) as { data: ResponseEvent };
      if (events.data.appCode === 20000) {
        for (const row of events.data.data) {
          let tmp = await HttpService.get(`${FilesEnumApi.asset}public/primary/${row.imgRef}`, {}, process.env.VUE_APP_API_FILES);
          if (tmp.data.data[0] === null) {
            row.img = 'https://timebank-spaces.sgp1.digitaloceanspaces.com/39dc8b1e-b9c2-4195-b2f8-ea2be77a7b8c.png';
          } else {
            row.img = tmp.data.data[0].filePath
          }
        }
        commit('mutationGetEventTime', events.data.data);
      } else {
        commit('mutationGetEventTime', []);
      }
    } catch (e) {
      commit('mutationGetEventTime', []);
      console.error('DEBUG: _getEvent ', e.message);
    }
  },

  async _getEventMemberForMainBranch(req: ActionContext<EventInitState, RootState>, params?: FilterEvent): Promise<void> {
    let {commit} = req;
    try {
      let events = await HttpService.get(`${EventEnumApi.event}member/main`, params) as { data: ResponseEvent };
      if (events.data.appCode === 20000) {
        for (const row of events.data.data) {
          let tmp = await HttpService.get(`${FilesEnumApi.asset}public/primary/${row.imgRef}`, {}, process.env.VUE_APP_API_FILES);
          if (tmp.data.data[0] === null) {
            row.img = 'https://timebank-spaces.sgp1.digitaloceanspaces.com/39dc8b1e-b9c2-4195-b2f8-ea2be77a7b8c.png';
          } else {
            row.img = tmp.data.data[0].filePath
          }
        }
        commit('mutationGetEventMemberMain', events.data.data);
      } else {
        commit('mutationGetEventMemberMain', []);
      }
    } catch (e) {
      commit('mutationGetEventMemberMain', []);
      console.error('DEBUG: _getEventMemberForMainBranch ', e.message);
    }
  }

};
